import { render, staticRenderFns } from "./promos-bars.vue?vue&type=template&id=2572abc4&"
import script from "./promos-bars.vue?vue&type=script&lang=js&"
export * from "./promos-bars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports